<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  (alt)="alt()"
>
  <div class="flex--container company-settings-container">
    <ng-container formGroupName="companySettings">
      @if (showGrasslandUsageDropdown) {
        <div class="flex__child--auto">
          <mat-form-field class="full-width-field">
            <mat-label>{{ 'grasslandUsage' | translate }}</mat-label>
            <mat-select
              formControlName="grasslandUsage"
              [placeholder]="'grasslandUsage' | translate"
              data-test="nitrogen-calculation-setting-grassland-usage"
            >
              @for (option of grasslandUsageOptions; track option) {
                <mat-option [value]="option">
                  {{ option.toLowerCase() | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'driftReduction' | translate }}</mat-label>
          <mat-select
            formControlName="driftReduction"
            [placeholder]="'driftReduction' | translate"
            data-test="editTreatment-driftReduction"
          >
            @for (percentage of driftReductions; track percentage) {
              <mat-option [value]="percentage"> {{ percentage }}%</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex__child">
        <mat-form-field class="full-width-field">
          <mat-label>{{ 'defaultSoilTypeVDM' | translate }}</mat-label>
          <mat-select
            formControlName="defaultSoilTypeId"
            [placeholder]="'defaultSoilTypeVDM' | translate"
            data-test="editTreatment-defaultSoilTypeVDM"
          >
            @for (soilType of soilTypes; track soilType) {
              <mat-option [value]="soilType.id"> {{ soilType.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <hr />
      <ng-container class="nitrogen-cuts--section" formGroupName="yearlySettings">
        <h3>{{ 'nitrogenCuts.sectionTitle' | translate }}</h3>
        <div class="flex__child">
          <div class="nitrogen-cuts-container">
            <label class="nitrogen-cuts--label"> {{ 'yearCap' | translate }} </label>
            <mat-form-field class="nitrogen-cuts--input">
              <input matInput [attr.disabled]="true" formControlName="year" />
            </mat-form-field>
          </div>
        </div>
        <h4 class="nitrogen-cuts--hectares-label">
          {{ 'hectares' | translate }}
        </h4>
        <ng-container formGroupName="nitrogenCuts" *ngrxLet="cropYear$ as cropYear">
          <div class="flex__child">
            <div class="nitrogen-cuts-container">
              <label class="nitrogen-cuts--label">
                @if (cropYear !== 2025) {
                  {{ 'nitrogenCuts.period1Label' | translate }}
                } @else {
                  {{ 'nitrogenCuts.period1Label2025' | translate }}
                }
              </label>
              <mat-form-field class="nitrogen-cuts--input">
                <input formControlName="cutsInHaPeriod1" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="flex__child">
            <div class="nitrogen-cuts-container">
              <label class="nitrogen-cuts--label">
                @if (cropYear !== 2025) {
                  {{ 'nitrogenCuts.period2Label' | translate }}
                } @else {
                  {{ 'nitrogenCuts.period2Label2025' | translate }}
                }
              </label>
              <mat-form-field class="nitrogen-cuts--input">
                <input formControlName="cutsInHaPeriod2" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="flex__child">
            <div class="nitrogen-cuts-container">
              <label class="nitrogen-cuts--label">
                @if (cropYear !== 2025) {
                  {{ 'nitrogenCuts.period3Label' | translate }}
                } @else {
                  {{ 'nitrogenCuts.period3Label2025' | translate }}
                }
              </label>
              <mat-form-field class="nitrogen-cuts--input">
                <input formControlName="cutsInHaPeriod3" matInput />
              </mat-form-field>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <hr />
      <div class="mat-slide-group-wrapper">
        <div class="mat-slide-group">
          <mat-slide-toggle
            color="primary"
            formControlName="automaticAdvice"
            data-test="company-settings__automaticAdvice"
          >
            {{ 'automaticAdvice' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </ng-container>
  </div>
</agr-form-dialog>
<img src="assets/uni.png" alt="uni" class="animated-icon" />
